module.exports = __webpack_public_path__ + "img/icon-efecty.7557b729.svg";